import { useNavigate, useLocation } from "react-router-dom";
import { ArrowUp, SpectraDarkSvg, SpectraSvg } from "../../../assets";
import { useTheme } from "../../../context/ThemeProvider";
import AddButton from "../../Button/AddButton";
import { motion } from "framer-motion";
import ROUTES from "../../../router/routes";
import UIStore from "../../../store/uiStore";

export const NewSpectraButton = () => {
  const { theme, colorScheme } = useTheme();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const setShowSidebar = UIStore((state) => state.setShowSidebar);

  const handleNewButtonClick = () => {
    navigate(ROUTES.SPECTRA.CREATE);
  };

  const handleNewSpectra = () => {
    navigate(ROUTES.SPECTRA.ROOT);
    // Close sidebar on mobile/tablet after navigation
    if (window.innerWidth < 940) {
      setShowSidebar(false);
    }
  };

  return (
    <motion.div
      className="flex items-center justify-between py-[10px] px-[12px]"
      initial="hover"
      whileHover="hover"
      animate="rest"
    >
      <motion.button
        type="button"
        aria-current={pathname.startsWith('/spectra') ? 'page' : undefined}
        className="photon-navigation-link flex items-center justify-between gap-[7px] cursor-pointer"
        onClick={handleNewSpectra}
        variants={{
          rest: {},
          hover: {},
        }}
      >
        {colorScheme === "docs" ? <SpectraSvg className="photon-navigation-icon photon-product-icon" aria-hidden="true" /> : theme === "dark" ? <SpectraDarkSvg /> : <SpectraSvg />}
        <motion.div
          className="photon-navigation-label text-sm font-semibold text-ink-control-border dark:text-ink-white"
          variants={{
            rest: {},
            hover: {},
          }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          inherit={false}
        >
          Spectra
        </motion.div>
        <motion.div
          className="ml-2 text-ink-ink-deep dark:text-ink-white"
          variants={{
            rest: { opacity: 0, x: -5 },
            hover: {
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.3,
                ease: "easeOut",
              },
            },
          }}
          inherit={false}
        >
          <ArrowUp className="dark:fill-ink-white fill-ink-ink-deep w-[11px] h-4 rotate-90" />
        </motion.div>
      </motion.button>
      <AddButton onClick={handleNewButtonClick}>New Spectra</AddButton>
    </motion.div>
  );
};
